import { Pipe, PipeTransform } from '@angular/core';
import { StatusPainelDeAtendimento as Status } from '../../enum/StatusAtendimento';

@Pipe({
  name: 'badgeStatusPainelDeAtendimento',
})
export class BadgeStatusPainelDeAtendimentoPipe implements PipeTransform {
  transform(status: Status): string {
    return {
      [Status.Aberto]: 'bg-warning text-dark',
      [Status.Fechado]: 'bg-success',
    }[status];
  }
}
